<template>
<div class="login">
    <el-form ref="loginRef" class="login-form" :rules="Rules" :model="registerForm">
      <h2 class="title">后台管理系统-登录</h2>

      <el-form-item prop="username">
        <el-input
          v-model="registerForm.username"
          type="text"
          size="large"
          auto-complete="off"
          placeholder="账号"
        ></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          v-model="registerForm.password"
          type="password"
          size="large"
          auto-complete="off"
          placeholder="密码"
        ></el-input>
      </el-form-item>

      <el-checkbox v-model="registerForm.rememberMe" style="margin:0px 0px 25px 0px;">记住密码</el-checkbox>

      <el-form-item style="width:100%;">
        <el-button
          size="large"
          type="primary"
          style="width:100%;"
          @click.prevent="denglu"
        >
          <span>登 录</span>
        </el-button>
      </el-form-item>

    </el-form>


  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { ref } from 'vue';
import request from "@/util/request";
import { ElMessage } from 'element-plus'; // 新增 ElMessageBox 用于状态提示
import Cookie from 'js-cookie';
import { encrypt, decrypt } from "@/util/jsencrypt";

const router = useRouter();



const registerForm = ref({
  username: '',
  password: '',
  rememberMe: false,
});
const loginRef = ref(null);

const Rules = {
  username: [
    { required: true, trigger: 'blur', message: '请输入账号' }
  ],
  password: [
    { required: true, trigger: 'blur', message: '请输入密码' }
  ]
};

// 核心登录逻辑（新增状态判断）
const denglu = () => {
  loginRef.value.validate(async (valid) => {
    if (valid) {
      try {
        let result = await request.post('user', registerForm.value);
        console.log(result);
        let data = result.data;

        if (data.code === 200) {
          ElMessage.success(data.info || '登录成功');
          // 存储 Token、用户信息、菜单列表
          window.sessionStorage.setItem('token', data.token);
          window.sessionStorage.setItem('user', JSON.stringify(data.user));
          window.sessionStorage.setItem('menulist', JSON.stringify(data.menulist));
          await router.push('/home');
          // 处理“记住密码”逻辑（保持原逻辑）
          if (registerForm.value.rememberMe) {
            Cookie.set('username', registerForm.value.username, { expires: 30 });
            Cookie.set('password', encrypt(registerForm.value.password), { expires: 30 });
            Cookie.set('rememberMe', registerForm.value.rememberMe, { expires: 30 });
          } else {
            Cookie.remove('username');
            Cookie.remove('password');
            Cookie.remove('rememberMe');
          }

        } else {
          ElMessage.error(data.info);
        }
      } catch (error) {
        console.error('登录请求异常：', error);
        ElMessage.error('网络异常，登录失败');
      }
    } else {
      console.log("验证失败");
    }
  });
};

// 读取 Cookie 填充表单（保持原逻辑）
function getCookie() {
  const username = Cookie.get('username');
  const password = Cookie.get('password');
  const rememberMe = Cookie.get('rememberMe');
  if (username !== undefined) {
    registerForm.value.username = username;
  }
  if (password !== undefined) {
    registerForm.value.password = decrypt(password);
  }
  registerForm.value.rememberMe = rememberMe !== undefined ? Boolean(rememberMe) : false;
}

getCookie();
</script>

<style lang="scss" scoped>
a{
  color:white
}
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-image: url("../assets/logo.png");
  background-size: cover;
}
.title {
  margin: 0px auto 30px auto;
  text-align: center;
  color: #707070;
}

.login-form {
  border-radius: 6px;
  background: #ffffff;
  width: 400px;
  padding: 25px 25px 5px 25px;

  .el-input {
    height: 40px;
    input {
      display: inline-block;
      height: 40px;
    }
  }
  .input-icon {
    height: 39px;
    width: 14px;
    margin-left: 0px;
  }

}
.login-tip {
  font-size: 13px;
  text-align: center;
  color: #bfbfbf;
}
.login-code {
  width: 33%;
  height: 40px;
  float: right;
  img {
    cursor: pointer;
    vertical-align: middle;
  }
}
.el-login-footer {
  height: 40px;
  line-height: 40px;
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  color: #fff;
  font-family: Arial;
  font-size: 12px;
  letter-spacing: 1px;
}
.login-code-img {
  height: 40px;
  padding-left: 12px;
}
</style>
